import React, { FC } from 'react';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import InputText, { InputType } from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import { setEmployerId } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const InputEmployerId: FC = () => {
    const employerId = useSelector((state) => state.acts.employerId);
    const dispatch = useDispatch();
    const trl = useTrls();

    return (
        <FormSpacer>
            <InputText
                type={InputType.Number}
                value={employerId || ''}
                onChange={(value: number) => dispatch(setEmployerId(value))}
                size="10"
                placeholder={trl('admin.actsReport.Filter.employerId')}
            />
        </FormSpacer>
    );
};

export default InputEmployerId;
